import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const TOPICS = [
  {
    id: 'bci', icon: 'ri-mental-health-line', title: '脑机接口', subtitle: 'Brain-Computer Interface',
    tag: '2028-2032', color: '#A855F7', episode: 'EP.01', storyTitle: '《意念之城》',
    headline: '意念操控元宇宙，思维即是命令',
    story: '2031年，上海。林晓雨戴上薄如蝉翼的BCI贴片，闭上眼睛——她的意识瞬间穿越进入"镜城"元宇宙。她只需"想"，就能在虚空中绘制建筑蓝图；她只需"感受"，就能与千里之外的同事共享同一片数字天空。那天，她用意念完成了一座跨越虚实的桥梁设计，而她的身体，从未离开过那把椅子。这不是科幻，这是2031年的日常。',
    desc: '脑机接口（BCI）技术将彻底颠覆人机交互范式。通过非侵入式神经信号采集，用户仅凭意念即可在元宇宙中移动、创作、交流。META66正与全球顶尖神经科学团队合作，推动BCI技术从实验室走向大众消费市场。',
    milestones: [
      { year: '2026', event: '非侵入式BCI设备消费级原型发布，延迟<100ms' },
      { year: '2028', event: '意念输入延迟降至50ms，支持基础元宇宙操控' },
      { year: '2030', event: 'BCI与XR设备深度集成，全感官元宇宙实现' },
      { year: '2032', event: '脑机接口大众普及，元宇宙成为第二现实' },
    ],
    img: 'https://public.readdy.ai/ai/img_res/a1520b3c05587909a03a27f0fc3ee5f4.jpg',
    stats: [{ label: '信号精度', value: '99.7%' }, { label: '延迟', value: '50ms' }, { label: '通道数', value: '1024+' }],
    applications: ['医疗康复', '元宇宙交互', '远程操控', '意识存档'],
    deepDive: '脑机接口的核心挑战在于神经信号的高精度采集与实时解码。目前主流技术路线分为侵入式（如Neuralink的N1芯片）和非侵入式（如EEG、fNIRS）两大类。META66重点布局非侵入式路线，通过AI算法大幅提升信号解码精度，目标在2028年实现消费级产品的大规模商用。',
  },
  {
    id: 'starlink', icon: 'ri-global-line', title: '星链与卫星互联', subtitle: 'Starlink & Satellite Internet',
    tag: '2025-2030', color: '#00FFCC', episode: 'EP.02', storyTitle: '《最后一公里》',
    headline: '万颗卫星织网，地球无死角连接',
    story: '2027年，西藏阿里高原，海拔5200米。牧民扎西打开手机，流畅地与北京的孙子视频通话，孙子正在元宇宙里上课，老师是一个来自哈佛的AI教授。扎西摇摇头笑了——他记得十年前，这里连2G信号都没有。如今，头顶的6000颗卫星让他和全球任何角落的人都处于同一张网络里。星链，让"数字鸿沟"成为历史。',
    desc: '以SpaceX星链为代表的低轨卫星互联网星座，正在构建覆盖全球每一寸土地的超高速网络。结合6G地面网络，将实现真正的"无处不在"连接，为元宇宙的全球普及奠定基础设施底座。',
    milestones: [
      { year: '2025', event: '全球卫星数量突破6000颗，覆盖率达95%' },
      { year: '2026', event: '卫星互联网延迟降至20ms，带宽突破1Gbps' },
      { year: '2028', event: '天地一体化网络成型，6G与卫星无缝切换' },
      { year: '2030', event: '全球100%覆盖，数字鸿沟彻底消除' },
    ],
    img: 'https://readdy.ai/api/search-image?query=starlink%20satellite%20constellation%20glowing%20cyan%20neon%20network%20earth%20orbit%20space%20internet%20connectivity%20futuristic%20technology%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic&width=900&height=500&seq=ft-starlink-v3&orientation=landscape',
    stats: [{ label: '卫星数量', value: '6000+' }, { label: '延迟', value: '20ms' }, { label: '覆盖率', value: '95%' }],
    applications: ['偏远地区覆盖', '海洋航运', '航空互联', '灾难救援'],
    deepDive: '低轨卫星互联网的核心优势在于轨道高度低（550-1200km），信号传播延迟远低于传统地球同步卫星（36000km）。SpaceX星链已在全球60多个国家提供服务，用户数超过200万。中国的"星网"计划也在加速推进，预计部署12992颗卫星，构建自主可控的天基互联网基础设施。',
  },
  {
    id: 'evtol', icon: 'ri-flight-takeoff-line', title: '低空经济 / eVTOL', subtitle: 'Low-Altitude Economy & eVTOL',
    tag: '2026-2035', color: '#FF6B35', episode: 'EP.03', storyTitle: '《空中通勤》',
    headline: '城市上空的第五维度，飞行出行新纪元',
    story: '2030年，深圳湾。陈明打开手机APP，预约了一辆eVTOL飞行出租车。7分钟后，一架安静的电动飞行器降落在楼顶停机坪。他坐进去，系好安全带，飞行器自动规划航线，穿越深圳湾上空，15分钟后降落在香港科技园。地面上，同样的路程需要90分钟。低空经济，让城市的第三维度成为日常通勤的新选择。',
    desc: '电动垂直起降飞行器（eVTOL）与低空经济正在重塑城市交通格局。大湾区已率先布局低空航线网络，预计2030年前实现城市间30分钟飞行通勤。结合AI自动驾驶与5G/6G实时通信，低空经济将创造万亿级新市场。',
    milestones: [
      { year: '2026', event: '大湾区首批eVTOL商业航线开通，载客运营' },
      { year: '2028', event: '全国主要城市低空航线网络成型，千架规模' },
      { year: '2030', event: 'eVTOL自动驾驶普及，城市空中交通系统建立' },
      { year: '2035', event: '低空经济产值突破5万亿，成为新支柱产业' },
    ],
    img: 'https://readdy.ai/api/search-image?query=eVTOL%20electric%20flying%20taxi%20urban%20air%20mobility%20city%20skyline%20glowing%20orange%20neon%20futuristic%20technology%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20low%20altitude%20economy&width=900&height=500&seq=ft-evtol-v3&orientation=landscape',
    stats: [{ label: '市场规模', value: '5万亿' }, { label: '通勤时间', value: '-80%' }, { label: '碳排放', value: '零排放' }],
    applications: ['城市通勤', '货物配送', '医疗急救', '旅游观光'],
    deepDive: '低空经济涵盖eVTOL、无人机物流、低空旅游等多个细分赛道。中国已将低空经济列为战略性新兴产业，2024年低空经济规模超5000亿元，预计2030年突破2万亿。大湾区、长三角、京津冀三大城市群正在率先构建低空航线网络，深圳已开通全国首条跨城eVTOL商业航线。',
  },
  {
    id: 'print3d', icon: 'ri-printer-line', title: '3D打印革命', subtitle: '3D Printing Revolution',
    tag: '2025-2032', color: '#00FF88', episode: 'EP.04', storyTitle: '《打印一座城市》',
    headline: '从分子到建筑，万物皆可打印',
    story: '2029年，成都天府新区。一台巨型3D打印机正在"打印"一栋18层的住宅楼。72小时后，这栋楼将完工，造价仅为传统建筑的30%。与此同时，在医院里，另一台生物3D打印机正在为一位患者打印一颗新的心脏——用他自己的细胞。3D打印，正在重写"制造"的定义。',
    desc: '3D打印技术正在从原型制造走向大规模生产，覆盖建筑、医疗、航空、食品等所有领域。生物3D打印可以打印人体器官，建筑3D打印可以在72小时内建造一栋楼，金属3D打印正在颠覆航空制造业。',
    milestones: [
      { year: '2025', event: '生物3D打印肾脏首次成功移植，患者存活' },
      { year: '2027', event: '建筑3D打印成本降至传统建筑20%，大规模推广' },
      { year: '2029', event: '食品3D打印进入家庭，个性化营养定制实现' },
      { year: '2032', event: '分子级3D打印实现，可打印任何材料结构' },
    ],
    img: 'https://readdy.ai/api/search-image?query=3D%20printing%20revolution%20futuristic%20manufacturing%20glowing%20green%20neon%20layer%20by%20layer%20construction%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20technology&width=900&height=500&seq=ft-3dp-v3&orientation=landscape',
    stats: [{ label: '成本降低', value: '-70%' }, { label: '打印速度', value: '100x提升' }, { label: '材料种类', value: '10000+' }],
    applications: ['生物器官打印', '建筑施工', '航空零件', '食品定制'],
    deepDive: '3D打印技术的核心突破来自三个方向：①材料科学——从塑料到金属、陶瓷、生物材料的全面覆盖；②精度提升——从毫米级到纳米级的精度革命；③速度革命——连续液体界面生产（CLIP）技术将打印速度提升100倍。生物3D打印是最具颠覆性的方向，通过将患者自身细胞作为"墨水"，可以打印出具有生物活性的器官，彻底解决器官移植短缺问题。',
  },
  {
    id: 'spatial', icon: 'ri-layout-3-line', title: '空间计算', subtitle: 'Spatial Computing',
    tag: '2025-2030', color: '#FF6B9D', episode: 'EP.05', storyTitle: '《无处不在的屏幕》',
    headline: '空间即界面，世界即操作系统',
    story: '2028年，北京。设计师王芳摘下眼镜，整个房间变成了她的工作台。墙壁上显示着项目进度，桌子上漂浮着3D模型，空气中流淌着数据流。她用手指轻轻一划，将一个设计方案"扔"给了远在纽约的同事。空间计算，让"屏幕"这个概念彻底消失了——整个世界都是屏幕。',
    desc: '空间计算是继PC、移动互联网之后的第三次计算平台革命。它将数字内容与物理空间完美融合，让用户在真实环境中与数字信息自然交互。Apple Vision Pro的发布标志着空间计算时代的正式开启。',
    milestones: [
      { year: '2025', event: 'Apple Vision Pro 2发布，空间计算生态爆发' },
      { year: '2027', event: '空间计算设备价格降至5000元，大众普及开始' },
      { year: '2029', event: '空间计算取代智能手机成为主流计算平台' },
      { year: '2032', event: '空间互联网标准确立，全球空间计算生态成熟' },
    ],
    img: 'https://readdy.ai/api/search-image?query=spatial%20computing%20augmented%20reality%20interface%20holographic%20display%20hands%20interaction%20glowing%20pink%20neon%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20technology&width=900&height=500&seq=ft-spatial-v3&orientation=landscape',
    stats: [{ label: '市场规模', value: '1.7万亿', }, { label: '设备出货', value: '5亿台/年' }, { label: '应用数量', value: '100万+' }],
    applications: ['远程协作', '沉浸教育', '医疗可视化', '工业设计'],
    deepDive: '空间计算的核心技术包括：①SLAM（同步定位与地图构建）——让设备实时理解三维空间；②手势识别——让双手成为最自然的输入设备；③眼动追踪——让视线成为精准的光标；④空间音频——让声音在三维空间中精确定位。Apple Vision Pro的M2+R1双芯片架构将传感器延迟降至12ms以内，实现了真正的"零延迟"空间计算体验。',
  },
  {
    id: 'space', icon: 'ri-rocket-line', title: '太空旅游', subtitle: 'Space Tourism',
    tag: '2027-2040', color: '#FF4081', episode: 'EP.06', storyTitle: '《轨道上的婚礼》',
    headline: '星辰大海不再遥远，人人皆可触摸宇宙',
    story: '2033年，国际空间站轨道高度400公里。张伟和李娜在太空中举行了人类历史上第一场"轨道婚礼"。地球在他们身后缓缓转动，蓝色的光晕映照着两人的脸。地面上，10亿人通过元宇宙全息直播同步见证了这一刻——仿佛自己也漂浮在星空之中。太空旅游，已经不再是亿万富翁的专属游戏。',
    desc: '随着SpaceX、蓝色起源、维珍银河等商业航天公司的竞争，太空旅游成本正在快速下降。预计2030年，亚轨道旅游票价将降至10万美元以内，轨道旅游将在2035年前实现商业化。太空旅游将与元宇宙深度融合，创造前所未有的体验经济。',
    milestones: [
      { year: '2027', event: '亚轨道旅游年旅客突破1万人次，票价降至20万' },
      { year: '2030', event: '商业空间站建成，轨道旅游开始商业运营' },
      { year: '2033', event: '月球旅游首班商业飞船发射，人类重返月球' },
      { year: '2040', event: '火星移民先遣队出发，人类成为多星球物种' },
    ],
    img: 'https://readdy.ai/api/search-image?query=space%20tourism%20rocket%20launch%20earth%20orbit%20glowing%20pink%20neon%20stars%20galaxy%20futuristic%20technology%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20commercial%20space%20travel&width=900&height=500&seq=ft-space-v3&orientation=landscape',
    stats: [{ label: '票价降幅', value: '-90%' }, { label: '年旅客', value: '10万+' }, { label: '目的地', value: '月球/火星' }],
    applications: ['太空旅游', '科学研究', '资源开采', '人类移民'],
    deepDive: '商业太空旅游的成本曲线正在快速下降，SpaceX的可复用火箭技术将发射成本降低了90%以上。目前亚轨道旅游（如维珍银河）票价约45万美元，预计2030年降至10万美元以内。轨道旅游（如SpaceX龙飞船）目前约5500万美元/人，预计2035年降至100万美元以内。月球旅游预计2033年开始商业运营，票价约5亿美元。',
  },
  {
    id: 'ai', icon: 'ri-brain-line', title: 'AI全面爆发', subtitle: 'AI Explosion & AGI',
    tag: '2025-2035', color: '#FFD700', episode: 'EP.07', storyTitle: '《最后一个程序员》',
    headline: '超级智能降临，人类文明的最大变量',
    story: '2032年，硅谷。前程序员马克坐在咖啡馆里，看着窗外的世界。他的工作已经被AI取代了——不是因为他不够好，而是因为AI太好了。但他并不悲伤。他现在是一名"AI导演"，用自然语言指挥AI构建整个数字世界。他的团队只有他一个人，却创造了一个拥有1亿用户的元宇宙游戏。AI，让一个人拥有了一支军队的创造力。',
    desc: 'AI正在以指数级速度进化，从专用AI到通用AI（AGI）的跨越预计在2030年前后实现。AI将全面渗透医疗、教育、创作、科研、制造等所有领域，重塑人类的工作方式与创造力边界。META66AI研究院正在探索AI与元宇宙的深度融合路径。',
    milestones: [
      { year: '2026', event: 'AI在所有专业领域超越人类专家水平' },
      { year: '2028', event: 'AGI雏形出现，具备跨领域自主推理能力' },
      { year: '2030', event: 'AI自主科研，每年产出相当于人类百年的成果' },
      { year: '2035', event: 'ASI（超级智能）出现，人类进入后奇点时代' },
    ],
    img: 'https://readdy.ai/api/search-image?query=artificial%20general%20intelligence%20AGI%20neural%20network%20explosion%20glowing%20golden%20yellow%20neon%20brain%20digital%20mind%20futuristic%20technology%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic&width=900&height=500&seq=ft-ai-v3&orientation=landscape',
    stats: [{ label: '算力增长', value: '100x/年' }, { label: '应用领域', value: '全行业' }, { label: '生产力提升', value: '1000x' }],
    applications: ['科学研究', '医疗诊断', '创意创作', '教育个性化'],
    deepDive: 'AI的发展遵循"感知→理解→推理→创造→自主"的五阶段路径。当前最先进的大语言模型已达到"理解"阶段的顶峰，正在向"推理"阶段突破。META66AI研究院重点布局AI与元宇宙的融合应用，包括AI生成内容（AIGC）、AI NPC、AI驱动的数字孪生等方向。',
  },
  {
    id: 'robot', icon: 'ri-robot-line', title: '人形机器人', subtitle: 'Humanoid Robots',
    tag: '2026-2035', color: '#00FFCC', episode: 'EP.08', storyTitle: '《我的机器人室友》',
    headline: '钢铁伙伴走进生活，人机共存新文明',
    story: '2031年，北京朝阳区。大学生小雨的公寓里多了一个室友——人形机器人"小蓝"。小蓝会做饭、会打扫、会辅导功课，还会在小雨失眠的夜晚陪她聊天。小蓝不需要睡觉，不会生气，永远耐心。小雨有时候会忘记小蓝是机器人——直到她看见小蓝充电时那双发光的眼睛。人形机器人，正在成为人类最亲密的伙伴。',
    desc: '以特斯拉Optimus、波士顿动力Atlas为代表的人形机器人正在快速走向实用化。预计2028年前，人形机器人将进入工厂、医院、家庭等场景，承担重复性、危险性工作。结合AI与元宇宙远程操控，人形机器人将成为人类在物理世界的"数字分身"。',
    milestones: [
      { year: '2026', event: '人形机器人进入工厂量产，替代危险岗位' },
      { year: '2028', event: '家用人形机器人上市，售价降至10万元以内' },
      { year: '2030', event: '人形机器人具备自主学习能力，适应复杂环境' },
      { year: '2035', event: '人形机器人数量超过人类，成为主要劳动力' },
    ],
    img: 'https://readdy.ai/api/search-image?query=humanoid%20robot%20futuristic%20glowing%20cyan%20neon%20artificial%20intelligence%20android%20walking%20city%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20technology&width=900&height=500&seq=ft-robot-v3&orientation=landscape',
    stats: [{ label: '售价', value: '<10万' }, { label: '工作时长', value: '24/7' }, { label: '任务完成率', value: '99.5%' }],
    applications: ['工厂制造', '家庭服务', '医疗护理', '灾难救援'],
    deepDive: '人形机器人的核心技术突破来自三个方向：①具身智能（Embodied AI）——让机器人像人类一样通过与环境交互来学习；②高性能执行器——轻量化、高扭矩的电机和液压系统；③多模态感知——视觉、触觉、听觉的融合感知。特斯拉Optimus已在工厂实现量产，国内宇树科技、智元机器人等也在快速追赶。',
  },
  {
    id: 'autonomous', icon: 'ri-car-line', title: '无人驾驶', subtitle: 'Autonomous Driving',
    tag: '2025-2030', color: '#FF6B35', episode: 'EP.09', storyTitle: '《最后一个司机》',
    headline: '方向盘消失的时代，出行彻底解放',
    story: '2030年，广州。出租车司机老李把他的最后一班车开完，停在了路边。他看着街上越来越多的无人驾驶出租车，叹了口气，又笑了。他的儿子在一家自动驾驶公司做工程师，月薪是他的十倍。老李掏出手机，叫了一辆无人驾驶出租车，坐进去，闭上眼睛。"这车开得比我稳多了，"他想，"也许这就是进步吧。"',
    desc: '无人驾驶技术正在从测试走向大规模商业化。百度Apollo、Waymo、特斯拉FSD等方案已在多个城市实现商业运营。预计2030年，L4级自动驾驶将在全球主要城市全面普及，彻底改变城市交通格局。',
    milestones: [
      { year: '2025', event: 'L4无人驾驶在10个中国城市获得商业运营许可' },
      { year: '2027', event: '无人驾驶出租车数量超过有人驾驶出租车' },
      { year: '2029', event: 'L5完全自动驾驶技术成熟，适应所有道路条件' },
      { year: '2032', event: '无人驾驶成为主流，交通事故率降低99%' },
    ],
    img: 'https://readdy.ai/api/search-image?query=autonomous%20self-driving%20car%20futuristic%20city%20night%20glowing%20orange%20neon%20lights%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20technology%20robotaxi&width=900&height=500&seq=ft-auto-v3&orientation=landscape',
    stats: [{ label: '事故降低', value: '-99%' }, { label: '效率提升', value: '+300%' }, { label: '城市覆盖', value: '100+' }],
    applications: ['城市出行', '货物运输', '老年服务', '应急救援'],
    deepDive: '无人驾驶的技术路线分为"纯视觉"（特斯拉FSD）和"激光雷达+视觉"（Waymo、百度）两大流派。特斯拉以海量真实驾驶数据训练神经网络，成本极低但安全性存争议；Waymo以激光雷达为主，安全性更高但成本较贵。中国百度Apollo采用"激光雷达+视觉+高精地图"的融合方案，已在北京、武汉、重庆等城市实现商业化运营。',
  },
  {
    id: 'quantum2', icon: 'ri-focus-3-line', title: '量子计算', subtitle: 'Quantum Computing',
    tag: '2026-2035', color: '#00FF88', episode: 'EP.10', storyTitle: '《破解宇宙密码》',
    headline: '量子霸权降临，经典计算机的终结',
    story: '2031年，合肥量子计算研究院。研究员陈博士盯着屏幕上的数字，手在颤抖。他们的量子计算机刚刚在3分钟内完成了一个传统超级计算机需要1万年才能完成的计算——破解了一个128位的加密密钥。"这意味着什么？"助手问。陈博士沉默了很久，说："这意味着，我们需要重新发明密码学。"',
    desc: '量子计算机利用量子叠加和量子纠缠，可以同时处理指数级数量的计算状态。在药物研发、密码学、金融建模、气候预测等领域，量子计算机的能力将远超任何经典计算机。中国、美国、欧盟正在展开激烈的量子霸权竞争。',
    milestones: [
      { year: '2026', event: '量子计算机突破1000量子比特，实现实用量子优越性' },
      { year: '2028', event: '量子云计算服务商业化，向企业开放' },
      { year: '2030', event: '量子计算机破解RSA-2048加密，后量子密码学全面部署' },
      { year: '2035', event: '通用量子计算机实现，经典超算全面退役' },
    ],
    img: 'https://readdy.ai/api/search-image?query=quantum%20computing%20processor%20glowing%20green%20neon%20qubits%20superconducting%20chip%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20technology%20futuristic%20laboratory&width=900&height=500&seq=ft-quantum-v3&orientation=landscape',
    stats: [{ label: '量子比特', value: '1000+' }, { label: '计算加速', value: '10^6倍' }, { label: '错误率', value: '<0.1%' }],
    applications: ['药物研发', '密码学', '金融建模', '气候预测'],
    deepDive: '量子计算的核心挑战是"量子纠错"——量子比特极易受到环境干扰而发生错误（退相干）。目前主流技术路线包括超导量子比特（IBM、Google）、离子阱（IonQ）、光量子（PsiQuantum）等。中国在量子通信领域处于全球领先地位，"九章"光量子计算机已实现特定任务的量子优越性。',
  },
  {
    id: 'nano', icon: 'ri-microscope-line', title: '纳米技术', subtitle: 'Nanotechnology',
    tag: '2028-2040', color: '#FF6B9D', episode: 'EP.11', storyTitle: '《体内的纳米军队》',
    headline: '分子级制造，重塑物质世界的底层逻辑',
    story: '2035年，上海瑞金医院。医生向患者注射了一管透明液体——里面含有10亿个纳米机器人。这些比细胞还小的机器人将在患者体内巡逻，精准识别并摧毁癌细胞，同时修复受损的DNA。三周后，患者的晚期癌症完全消失。纳米技术，让"不治之症"成为历史。',
    desc: '纳米技术正在从实验室走向实际应用，在医疗、材料、能源、电子等领域展现出颠覆性潜力。纳米机器人可以在人体内执行精准医疗任务，纳米材料可以创造出具有超常性能的新型材料，纳米电子学将推动芯片性能突破物理极限。',
    milestones: [
      { year: '2028', event: '纳米药物载体实现精准靶向给药，癌症治愈率突破90%' },
      { year: '2030', event: '纳米机器人首次在人体内完成手术任务' },
      { year: '2033', event: '纳米材料实现工业化生产，性能超越所有传统材料' },
      { year: '2040', event: '分子机器实现，可在原子级别操控物质' },
    ],
    img: 'https://readdy.ai/api/search-image?query=nanotechnology%20nanorobots%20medical%20futuristic%20glowing%20pink%20neon%20molecular%20machines%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20technology&width=900&height=500&seq=ft-nano-v3&orientation=landscape',
    stats: [{ label: '癌症治愈率', value: '90%+' }, { label: '精度', value: '纳米级' }, { label: '应用领域', value: '全行业' }],
    applications: ['精准医疗', '新型材料', '能源存储', '芯片制造'],
    deepDive: '纳米技术的核心是在1-100纳米尺度上操控物质。在这个尺度上，物质的性质与宏观世界完全不同——金变成红色、碳变成比钢铁强100倍的碳纳米管。医疗纳米机器人是最具颠覆性的应用方向，通过DNA折纸技术、分子马达等手段，科学家已经制造出能够在细胞内执行特定任务的纳米机器。',
  },
  {
    id: 'fusion', icon: 'ri-fire-line', title: '核聚变能源', subtitle: 'Nuclear Fusion Energy',
    tag: '2030-2050', color: '#FF6B35', episode: 'EP.12', storyTitle: '《人造太阳》',
    headline: '终极能源降临，人类文明的能源自由',
    story: '2040年，法国卡达拉什。ITER核聚变反应堆第一次实现了"点火"——输出能量超过输入能量10倍。控制室里，来自35个国家的科学家们相拥而泣。这一刻，人类等待了70年。从此，能源不再是问题。海水中的氘足够人类使用数十亿年。文明的枷锁，终于被打开了。',
    desc: '核聚变是太阳的能量来源，也是人类追求了70年的终极能源梦想。与核裂变不同，核聚变几乎没有放射性废料，燃料来自海水，安全清洁且几乎无限。ITER国际热核聚变实验堆项目预计2035年实现首次点火，商业核聚变电站有望在2050年前建成。',
    milestones: [
      { year: '2030', event: 'NIF激光核聚变实现净能量增益，Q值突破10' },
      { year: '2035', event: 'ITER实现首次等离子体点火，验证商业可行性' },
      { year: '2040', event: '首座商业核聚变示范电站建成，开始发电' },
      { year: '2050', event: '核聚变电站全球部署，人类实现能源自由' },
    ],
    img: 'https://readdy.ai/api/search-image?query=nuclear%20fusion%20reactor%20tokamak%20plasma%20glowing%20orange%20neon%20energy%20futuristic%20technology%20dark%20background%20sci-fi%20cinematic%20ultra%20detailed%20artistic%20clean%20energy&width=900&height=500&seq=ft-fusion-v3&orientation=landscape',
    stats: [{ label: '能量密度', value: '1000万倍', }, { label: '燃料来源', value: '海水' }, { label: '废料', value: '近零' }],
    applications: ['清洁发电', '太空推进', '海水淡化', '工业供热'],
    deepDive: '核聚变的核心挑战是"约束等离子体"——将温度高达1亿摄氏度的等离子体（比太阳核心还热）约束在有限空间内足够长的时间。主流技术路线包括托卡马克（ITER采用）、惯性约束（NIF激光）和仿星器三种。2022年，美国NIF实验室首次实现核聚变净能量增益，标志着人类距离商业核聚变又近了一大步。',
  },
];

// Biometric experience component with sci-fi animation
function BiometricExperience({ color }: { color: string }) {
  const [scanning, setScanning] = useState(false);
  const [scanProgress, setScanProgress] = useState(0);
  const [scanResult, setScanResult] = useState<string | null>(null);
  const [activeMode, setActiveMode] = useState<'iris' | 'fingerprint' | 'face' | 'dna'>('iris');

  const startScan = () => {
    if (scanning) return;
    setScanning(true);
    setScanResult(null);
    setScanProgress(0);
    let progress = 0;
    const interval = setInterval(() => {
      progress += Math.random() * 8 + 3;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
        setTimeout(() => {
          setScanning(false);
          setScanResult('IDENTITY VERIFIED · ACCESS GRANTED · NEXUS-1 ACTIVATED');
        }, 300);
      }
      setScanProgress(Math.min(progress, 100));
    }, 80);
  };

  const modes = [
    { id: 'iris', label: '虹膜', icon: 'ri-eye-line' },
    { id: 'fingerprint', label: '指纹', icon: 'ri-fingerprint-line' },
    { id: 'face', label: '面部', icon: 'ri-user-smile-line' },
    { id: 'dna', label: 'DNA', icon: 'ri-dna-line' },
  ] as const;

  return (
    <div className="relative p-6 rounded-2xl overflow-hidden" style={{ background: 'rgba(0,0,0,0.6)', border: `2px solid ${color}40` }}>
      {/* Animated border glow */}
      <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{ boxShadow: scanning ? `0 0 30px ${color}60, inset 0 0 30px ${color}10` : `0 0 10px ${color}20`, transition: 'box-shadow 0.5s ease', animation: scanning ? 'borderPulse 1s infinite' : 'none' }} />

      {/* Corner decorations */}
      {[['top-2 left-2', 'border-t-2 border-l-2'], ['top-2 right-2', 'border-t-2 border-r-2'], ['bottom-2 left-2', 'border-b-2 border-l-2'], ['bottom-2 right-2', 'border-b-2 border-r-2']].map(([pos, border], i) => (
        <div key={i} className={`absolute ${pos} w-5 h-5 ${border}`} style={{ borderColor: color, opacity: scanning ? 1 : 0.5, transition: 'opacity 0.3s' }} />
      ))}

      <h3 className="text-white font-black text-lg mb-4 text-center" style={{ fontFamily: 'Orbitron, sans-serif', letterSpacing: '0.1em' }}>
        <span style={{ color }}>BIOMETRIC</span> SCANNER
      </h3>

      {/* Mode selector */}
      <div className="flex gap-2 mb-5 justify-center">
        {modes.map(m => (
          <button key={m.id} onClick={() => { setActiveMode(m.id); setScanResult(null); setScanProgress(0); }} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold cursor-pointer whitespace-nowrap transition-all duration-200" style={{ background: activeMode === m.id ? `${color}25` : 'rgba(255,255,255,0.05)', border: `1px solid ${activeMode === m.id ? color + '40' : 'rgba(255,255,255,0.06)'}`, color: activeMode === m.id ? color : 'rgba(255,255,255,0.4)', transform: activeMode === m.id ? 'scale(1.05)' : 'scale(1)' }}>
            <i className={m.icon} />{m.label}
          </button>
        ))}
      </div>

      {/* Scanner display */}
      <div className="relative flex items-center justify-center mb-5" style={{ height: '180px' }}>
        {/* Outer ring */}
        <div className="absolute" style={{ width: '160px', height: '160px', borderRadius: '50%', border: `2px solid ${color}30`, animation: scanning ? 'spin 3s linear infinite' : 'none' }}>
          <div style={{ position: 'absolute', top: '-3px', left: '50%', transform: 'translateX(-50%)', width: '6px', height: '6px', borderRadius: '50%', background: color, boxShadow: `0 0 10px ${color}` }} />
        </div>
        {/* Middle ring */}
        <div className="absolute" style={{ width: '120px', height: '120px', borderRadius: '50%', border: `1.5px solid ${color}50`, animation: scanning ? 'spinReverse 2s linear infinite' : 'none' }}>
          {[0, 90, 180, 270].map(deg => (
            <div key={deg} style={{ position: 'absolute', top: '-2px', left: '50%', transform: `translateX(-50%) rotate(${deg}deg)`, transformOrigin: '50% 62px', width: '4px', height: '4px', borderRadius: '50%', background: color, opacity: 0.7 }} />
          ))}
        </div>
        {/* Inner display */}
        <div className="relative flex items-center justify-center" style={{ width: '90px', height: '90px', borderRadius: '50%', background: `radial-gradient(circle, ${color}15, rgba(0,0,0,0.8))`, border: `2px solid ${color}60`, boxShadow: scanning ? `0 0 25px ${color}50` : `0 0 10px ${color}20`, transition: 'box-shadow 0.3s' }}>
          {activeMode === 'iris' && (
            <div style={{ width: '50px', height: '50px', borderRadius: '50%', background: `radial-gradient(circle, #000 20%, ${color}40 40%, ${color}20 60%, transparent 80%)`, border: `2px solid ${color}`, boxShadow: `0 0 15px ${color}60` }}>
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '14px', height: '14px', borderRadius: '50%', background: '#000', border: `1px solid ${color}` }} />
            </div>
          )}
          {activeMode === 'fingerprint' && (
            <div style={{ position: 'relative', width: '50px', height: '50px' }}>
              {[0,1,2,3,4].map(i => (
                <div key={i} style={{ position: 'absolute', top: `${5 + i * 8}px`, left: `${5 + i * 2}px`, right: `${5 + i * 2}px`, height: '3px', borderRadius: '50%', border: `1.5px solid ${color}`, opacity: 0.7 + i * 0.08 }} />
              ))}
            </div>
          )}
          {activeMode === 'face' && (
            <div style={{ width: '44px', height: '52px', borderRadius: '50% 50% 45% 45%', border: `2px solid ${color}`, position: 'relative' }}>
              <div style={{ position: 'absolute', top: '14px', left: '8px', width: '8px', height: '5px', borderRadius: '50%', background: color }} />
              <div style={{ position: 'absolute', top: '14px', right: '8px', width: '8px', height: '5px', borderRadius: '50%', background: color }} />
              <div style={{ position: 'absolute', bottom: '10px', left: '50%', transform: 'translateX(-50%)', width: '18px', height: '4px', borderRadius: '0 0 8px 8px', border: `1.5px solid ${color}`, borderTop: 'none' }} />
            </div>
          )}
          {activeMode === 'dna' && (
            <div style={{ position: 'relative', width: '20px', height: '50px' }}>
              {[0,1,2,3,4,5].map(i => (
                <div key={i} style={{ position: 'absolute', top: `${i * 8}px`, left: i % 2 === 0 ? '-8px' : '8px', width: '16px', height: '3px', background: color, borderRadius: '2px', opacity: 0.7 + (i % 2) * 0.3 }} />
              ))}
              <div style={{ position: 'absolute', top: 0, left: '50%', transform: 'translateX(-50%)', width: '2px', height: '100%', background: `linear-gradient(180deg, ${color}80, ${color}20)` }} />
            </div>
          )}
          {/* Scan line */}
          {scanning && (
            <div className="absolute inset-0 rounded-full overflow-hidden">
              <div style={{ position: 'absolute', top: `${scanProgress}%`, left: 0, right: 0, height: '2px', background: `linear-gradient(90deg, transparent, ${color}, transparent)`, boxShadow: `0 0 8px ${color}`, transition: 'top 0.1s linear' }} />
            </div>
          )}
        </div>
        {/* Scan progress arc */}
        {scanning && (
          <svg className="absolute" style={{ width: '170px', height: '170px', top: '-5px', left: '50%', transform: 'translateX(-50%)' }}>
            <circle cx="85" cy="85" r="80" fill="none" stroke={color} strokeWidth="2" strokeDasharray={`${scanProgress * 5.03} 503`} strokeLinecap="round" style={{ transform: 'rotate(-90deg)', transformOrigin: '85px 85px', filter: `drop-shadow(0 0 6px ${color})` }} />
          </svg>
        )}
      </div>

      {/* Progress bar */}
      {(scanning || scanProgress > 0) && (
        <div className="mb-4">
          <div className="flex justify-between text-xs mb-1.5" style={{ color: 'rgba(255,255,255,0.5)' }}>
            <span>SCANNING...</span>
            <span style={{ color, fontFamily: 'Orbitron, sans-serif' }}>{Math.round(scanProgress)}%</span>
          </div>
          <div className="h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.08)' }}>
            <div className="h-full rounded-full transition-all duration-100" style={{ width: `${scanProgress}%`, background: `linear-gradient(90deg, ${color}, ${color}80)`, boxShadow: `0 0 8px ${color}` }} />
          </div>
        </div>
      )}

      {/* Result */}
      {scanResult && (
        <div className="mb-4 p-3 rounded-xl text-center" style={{ background: `${color}10`, border: `1px solid ${color}40`, animation: 'fadeIn 0.5s ease' }}>
          <i className="ri-checkbox-circle-line text-xl mb-1 block" style={{ color }} />
          <p className="text-xs font-bold" style={{ color, fontFamily: 'Orbitron, sans-serif', letterSpacing: '0.05em' }}>{scanResult}</p>
        </div>
      )}

      {/* Scan button */}
      <button onClick={startScan} disabled={scanning} className="w-full py-3 font-black text-sm cursor-pointer whitespace-nowrap rounded-xl transition-all duration-300 hover:scale-105" style={{ background: scanning ? `${color}10` : `linear-gradient(135deg, ${color}25, ${color}15)`, border: `2px solid ${color}${scanning ? '30' : '60'}`, color: scanning ? `${color}60` : color, fontFamily: 'Orbitron, sans-serif', letterSpacing: '0.1em', boxShadow: scanning ? 'none' : `0 0 20px ${color}20` }}>
        {scanning ? 'SCANNING...' : 'INITIATE BIOMETRIC SCAN'}
      </button>

      <style>{`
        @keyframes borderPulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.6; } }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes spinReverse { from { transform: rotate(360deg); } to { transform: rotate(0deg); } }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(5px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}

export default function FutureTechPage() {
  const navigate = useNavigate();
  const [activeTopic, setActiveTopic] = useState(TOPICS[0]);
  const [showStory, setShowStory] = useState(false);
  const [showDeepDive, setShowDeepDive] = useState(false);
  const [heroVisible, setHeroVisible] = useState(false);
  const [hoveredGrid, setHoveredGrid] = useState<string | null>(null);
  const [tooltipTopic, setTooltipTopic] = useState<typeof TOPICS[0] | null>(null);
  const [tooltipPos, setTooltipPos] = useState({ x: 0, y: 0 });
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'META66前沿科技 | 脑机接口·星链·eVTOL·AI爆发·人形机器人·太空旅游';
    setTimeout(() => setHeroVisible(true), 100);
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    const particles: { x: number; y: number; vx: number; vy: number; r: number; alpha: number }[] = [];
    for (let i = 0; i < 100; i++) {
      particles.push({ x: Math.random() * canvas.width, y: Math.random() * canvas.height, vx: (Math.random() - 0.5) * 0.25, vy: (Math.random() - 0.5) * 0.25, r: Math.random() * 1.5 + 0.3, alpha: Math.random() * 0.25 + 0.05 });
    }
    let animId: number;
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      particles.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
        if (p.y < 0 || p.y > canvas.height) p.vy *= -1;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(0,255,200,${p.alpha})`;
        ctx.fill();
      });
      animId = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(animId);
  }, []);

  const handleTopicChange = (t: typeof TOPICS[0]) => {
    setActiveTopic(t);
    setShowStory(false);
    setShowDeepDive(false);
  };

  return (
    <div className="min-h-screen" style={{ background: '#020810', fontFamily: "'Inter', 'PingFang SC', sans-serif" }}>
      <canvas ref={canvasRef} className="fixed inset-0 w-full h-full pointer-events-none" style={{ zIndex: 0 }} />

      {/* Header */}
      <div className="sticky top-0 z-50" style={{ background: 'rgba(2,8,16,0.95)', borderBottom: '1px solid rgba(0,255,200,0.1)', backdropFilter: 'blur(20px)' }}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-sm font-medium cursor-pointer whitespace-nowrap transition-all hover:scale-105" style={{ color: 'rgba(0,255,200,0.7)' }}>
            <i className="ri-arrow-left-line" />返回首页
          </button>
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: 'rgba(255,215,0,0.1)', border: '1px solid rgba(255,215,0,0.3)' }}>
              <i className="ri-flashlight-line text-sm" style={{ color: '#FFD700' }} />
            </div>
            <span className="font-bold text-white text-base" style={{ fontFamily: 'Orbitron, sans-serif' }}>FUTURE FRONTIERS</span>
          </div>
          <div className="text-sm" style={{ color: 'rgba(255,215,0,0.4)' }}>META66 · 12大前沿科技</div>
        </div>
      </div>

      {/* Hero */}
      <div className="relative overflow-hidden" style={{ height: '460px', zIndex: 1 }}>
        <img src={activeTopic.img} alt="前沿科技" className="w-full h-full object-cover object-top transition-all duration-700" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(2,8,16,0.3) 0%, rgba(2,8,16,0.6) 50%, rgba(2,8,16,1) 100%)' }} />
        <div className="absolute inset-0 flex items-end pb-14 px-12" style={{ zIndex: 2 }}>
          <div style={{ opacity: heroVisible ? 1 : 0, transform: heroVisible ? 'translateY(0)' : 'translateY(30px)', transition: 'all 0.8s ease' }}>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full mb-5" style={{ background: `${activeTopic.color}20`, border: `1px solid ${activeTopic.color}40` }}>
              <span className="text-sm font-bold" style={{ color: activeTopic.color }}>{activeTopic.episode}</span>
              <span className="text-white/40 text-sm">·</span>
              <span className="text-white/50 text-sm">{activeTopic.tag}</span>
            </div>
            <h1 className="text-6xl md:text-7xl font-black text-white mb-4" style={{ fontFamily: 'Orbitron, sans-serif' }}>FUTURE<br /><span style={{ color: activeTopic.color }}>FRONTIERS</span></h1>
            <p className="text-white/70 text-xl max-w-2xl leading-relaxed">{activeTopic.headline}</p>
          </div>
        </div>
      </div>

      {/* Topic Selector */}
      <div className="sticky z-40" style={{ top: '65px', background: 'rgba(2,8,16,0.95)', borderBottom: '1px solid rgba(255,255,255,0.06)', backdropFilter: 'blur(20px)' }}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex gap-1 overflow-x-auto py-3" style={{ scrollbarWidth: 'none' }}>
            {TOPICS.map(t => (
              <button key={t.id} onClick={() => handleTopicChange(t)}
                className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
                style={{
                  background: activeTopic.id === t.id ? `${t.color}15` : 'transparent',
                  color: activeTopic.id === t.id ? t.color : 'rgba(255,255,255,0.4)',
                  border: `1px solid ${activeTopic.id === t.id ? t.color + '40' : 'transparent'}`,
                  boxShadow: activeTopic.id === t.id ? `0 0 15px ${t.color}20` : 'none',
                }}>
                <i className={t.icon} />
                {t.title}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-20">
          {/* Left: Main Content */}
          <div className="lg:col-span-2 flex flex-col gap-6">
            <div>
              <p className="text-sm font-bold tracking-widest uppercase mb-3" style={{ color: activeTopic.color }}>{activeTopic.subtitle}</p>
              <h2 className="text-4xl font-black text-white mb-3" style={{ fontFamily: 'Orbitron, sans-serif' }}>{activeTopic.title}</h2>
              <p className="text-2xl font-semibold mb-5" style={{ color: activeTopic.color }}>{activeTopic.headline}</p>
              <p className="text-white/60 leading-relaxed text-base">{activeTopic.desc}</p>
            </div>

            {/* Story Toggle */}
            <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${activeTopic.color}20` }}>
              <button onClick={() => setShowStory(!showStory)} className="w-full flex items-center justify-between p-5 transition-colors cursor-pointer hover:bg-white/5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${activeTopic.color}15` }}>
                    <i className="ri-book-open-line text-lg" style={{ color: activeTopic.color }} />
                  </div>
                  <div className="text-left">
                    <p className="font-bold text-white text-base">{activeTopic.storyTitle}</p>
                    <p className="text-white/30 text-sm">{activeTopic.episode} · 点击阅读完整故事</p>
                  </div>
                </div>
                <i className={`${showStory ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-white/40 text-xl`} />
              </button>
              {showStory && (
                <div className="px-5 pb-5 border-t" style={{ borderColor: `${activeTopic.color}15` }}>
                  <p className="text-white/60 leading-relaxed pt-4 italic text-base" style={{ lineHeight: '2' }}>{activeTopic.story}</p>
                </div>
              )}
            </div>

            {/* Deep Dive Toggle */}
            <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.03)', border: `1px solid ${activeTopic.color}20` }}>
              <button onClick={() => setShowDeepDive(!showDeepDive)} className="w-full flex items-center justify-between p-5 transition-colors cursor-pointer hover:bg-white/5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: `${activeTopic.color}15` }}>
                    <i className="ri-microscope-line text-lg" style={{ color: activeTopic.color }} />
                  </div>
                  <div className="text-left">
                    <p className="font-bold text-white text-base">技术深度解析</p>
                    <p className="text-white/30 text-sm">点击展开专业技术分析</p>
                  </div>
                </div>
                <i className={`${showDeepDive ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-white/40 text-xl`} />
              </button>
              {showDeepDive && (
                <div className="px-5 pb-5 border-t" style={{ borderColor: `${activeTopic.color}15` }}>
                  <p className="text-white/60 leading-relaxed pt-4 text-base" style={{ lineHeight: '2' }}>{activeTopic.deepDive}</p>
                </div>
              )}
            </div>

            {/* Milestones */}
            <div>
              <h3 className="font-bold text-white text-lg mb-5 flex items-center gap-2">
                <i className="ri-map-pin-time-line" style={{ color: activeTopic.color }} />
                技术路线图
              </h3>
              <div className="relative">
                <div className="absolute left-4 top-0 bottom-0 w-px" style={{ background: `linear-gradient(to bottom, ${activeTopic.color}60, transparent)` }} />
                {activeTopic.milestones.map((m, i) => (
                  <div key={m.year} className="flex items-start gap-4 mb-5 last:mb-0">
                    <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 z-10 text-xs font-black text-black" style={{ background: activeTopic.color }}>
                      {i + 1}
                    </div>
                    <div className="flex-1 pt-1 pb-4 border-b" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
                      <span className="font-black text-base mr-2" style={{ color: activeTopic.color, fontFamily: 'Orbitron, sans-serif' }}>{m.year}</span>
                      <span className="text-white/60 text-base">{m.event}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Biometric Experience - only show for BCI topic */}
            {activeTopic.id === 'bci' && (
              <BiometricExperience color={activeTopic.color} />
            )}
          </div>

          {/* Right: Stats + Applications + Episode */}
          <div className="flex flex-col gap-4">
            {/* Stats */}
            <div className="p-5 rounded-2xl" style={{ background: `${activeTopic.color}06`, border: `1px solid ${activeTopic.color}20` }}>
              <h3 className="font-bold text-white text-base mb-4">关键数据</h3>
              {activeTopic.stats.map(s => (
                <div key={s.label} className="flex justify-between items-center py-3 border-b" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
                  <span className="text-white/50 text-base">{s.label}</span>
                  <span className="font-black text-2xl" style={{ color: activeTopic.color, fontFamily: 'Orbitron, sans-serif' }}>{s.value}</span>
                </div>
              ))}
            </div>

            {/* Applications */}
            <div className="p-5 rounded-2xl" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <h3 className="font-bold text-white text-base mb-4">应用场景</h3>
              <div className="grid grid-cols-2 gap-2">
                {activeTopic.applications.map(app => (
                  <div key={app} className="p-3 rounded-xl text-center text-sm font-semibold" style={{ background: `${activeTopic.color}10`, color: activeTopic.color, border: `1px solid ${activeTopic.color}20` }}>
                    {app}
                  </div>
                ))}
              </div>
            </div>

            {/* Episode Info */}
            <div className="p-5 rounded-2xl" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="flex items-center gap-2 mb-3">
                <span className="px-3 py-1 rounded-full text-sm font-bold" style={{ background: `${activeTopic.color}15`, color: activeTopic.color, border: `1px solid ${activeTopic.color}30` }}>{activeTopic.episode}</span>
                <span className="text-white/30 text-sm">{activeTopic.tag}</span>
              </div>
              <p className="font-bold text-white text-base mb-1">{activeTopic.storyTitle}</p>
              <p className="text-white/30 text-sm">{activeTopic.subtitle}</p>
            </div>

            {/* CTA */}
            <div className="p-5 rounded-2xl text-center" style={{ background: `${activeTopic.color}08`, border: `1px solid ${activeTopic.color}25` }}>
              <p className="font-bold text-white text-base mb-2">深度解析此科技</p>
              <p className="text-white/30 text-sm mb-4">查看完整技术分析、突破进展与发展路线</p>
              <button onClick={() => navigate(`/future-tech/${activeTopic.id}`)} className="w-full py-3 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer text-black transition-all hover:scale-105 mb-2" style={{ background: activeTopic.color }}>
                进入深度解析页
              </button>
              <button onClick={() => navigate('/')} className="w-full py-2.5 rounded-xl font-bold text-sm whitespace-nowrap cursor-pointer transition-all hover:scale-105" style={{ background: 'rgba(255,255,255,0.05)', color: 'rgba(255,255,255,0.4)', border: '1px solid rgba(255,255,255,0.08)' }}>
                返回首页
              </button>
            </div>
          </div>
        </div>

        {/* ===== All Topics Grid - DEEPLY BEAUTIFIED ===== */}
        <div>
          <div className="text-center mb-10">
            <h2 className="text-4xl font-black text-white mb-3" style={{ fontFamily: 'Orbitron, sans-serif' }}>
              <span style={{ color: '#FFD700' }}>12</span> 大前沿科技全览
            </h2>
            <p className="text-white/40 text-base">点击任意科技领域，深入探索改变世界的力量</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
            {TOPICS.map((t) => {
              const isActive = activeTopic.id === t.id;
              const isHovered = hoveredGrid === t.id;
              return (
                <button
                  key={t.id}
                  onClick={() => navigate(`/future-tech/${t.id}`)}
                  onMouseEnter={() => setHoveredGrid(t.id)}
                  onMouseLeave={() => setHoveredGrid(null)}
                  className="relative p-4 rounded-2xl text-center transition-all cursor-pointer overflow-hidden"
                  style={{
                    background: isActive
                      ? `linear-gradient(135deg, ${t.color}20, ${t.color}08)`
                      : isHovered
                        ? `linear-gradient(135deg, ${t.color}15, ${t.color}05)`
                        : 'rgba(255,255,255,0.03)',
                    border: `1.5px solid ${isActive ? t.color + '60' : isHovered ? t.color + '40' : 'rgba(255,255,255,0.06)'}`,
                    transform: isHovered ? 'translateY(-6px) scale(1.03)' : isActive ? 'translateY(-3px)' : 'translateY(0)',
                    boxShadow: isActive
                      ? `0 10px 40px ${t.color}30, 0 0 0 1px ${t.color}20`
                      : isHovered
                        ? `0 8px 30px ${t.color}25, 0 0 0 1px ${t.color}15`
                        : 'none',
                    transition: 'all 0.35s cubic-bezier(0.34,1.56,0.64,1)',
                  }}
                >
                  {/* Background glow */}
                  <div className="absolute inset-0 pointer-events-none" style={{ background: `radial-gradient(ellipse at 50% 0%, ${t.color}${isHovered || isActive ? '20' : '00'} 0%, transparent 70%)`, transition: 'background 0.3s' }} />

                  {/* Episode badge */}
                  <div className="absolute top-2 right-2 text-xs font-bold" style={{ color: `${t.color}60`, fontFamily: 'Orbitron, sans-serif', fontSize: '0.6rem' }}>{t.episode}</div>

                  {/* Icon */}
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3 transition-all duration-300" style={{ background: isHovered || isActive ? `${t.color}20` : `${t.color}10`, border: `1.5px solid ${isHovered || isActive ? t.color + '60' : t.color + '20'}`, boxShadow: isHovered || isActive ? `0 0 20px ${t.color}40` : 'none', transform: isHovered ? 'scale(1.15) rotate(5deg)' : 'scale(1) rotate(0deg)', transition: 'all 0.3s ease' }}>
                    <i className={`${t.icon} text-xl`} style={{ color: t.color, filter: isHovered || isActive ? `drop-shadow(0 0 6px ${t.color})` : 'none', transition: 'filter 0.3s' }} />
                  </div>

                  {/* Title */}
                  <div className="font-bold text-sm mb-1 transition-colors duration-300" style={{ color: isActive || isHovered ? '#fff' : 'rgba(255,255,255,0.6)', fontSize: '0.8rem' }}>{t.title}</div>

                  {/* Tag */}
                  <div className="text-xs transition-colors duration-300" style={{ color: isActive || isHovered ? t.color : 'rgba(255,255,255,0.2)', fontSize: '0.65rem', fontFamily: 'Orbitron, sans-serif' }}>{t.tag}</div>

                  {/* Active indicator */}
                  {isActive && (
                    <div className="absolute bottom-0 left-0 right-0 h-0.5 rounded-b-2xl" style={{ background: `linear-gradient(90deg, transparent, ${t.color}, transparent)`, boxShadow: `0 0 8px ${t.color}` }} />
                  )}

                  {/* Hover scan line */}
                  {isHovered && !isActive && (
                    <div className="absolute inset-0 pointer-events-none overflow-hidden rounded-2xl">
                      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '1px', background: `linear-gradient(90deg, transparent, ${t.color}80, transparent)`, animation: 'scanDown 1.5s linear infinite' }} />
                    </div>
                  )}

                  {/* Hover Tooltip - Enhanced */}
                  {isHovered && (
                    <div className="absolute bottom-full left-1/2 mb-3 z-50 pointer-events-none" style={{ transform: 'translateX(-50%)', width: '260px' }}>
                      <div className="rounded-2xl p-4" style={{ background: 'rgba(2,8,16,0.99)', border: `1.5px solid ${t.color}60`, boxShadow: `0 12px 50px ${t.color}35, 0 0 0 1px ${t.color}15`, backdropFilter: 'blur(24px)' }}>
                        {/* Header */}
                        <div className="flex items-center gap-2 mb-3">
                          <div className="w-8 h-8 rounded-xl flex items-center justify-center flex-shrink-0" style={{ background: `${t.color}20`, border: `1px solid ${t.color}40` }}>
                            <i className={`${t.icon} text-sm`} style={{ color: t.color }} />
                          </div>
                          <div>
                            <span className="font-black text-white text-xs block" style={{ fontFamily: 'Orbitron, sans-serif' }}>{t.title}</span>
                            <span className="text-xs" style={{ color: `${t.color}80`, fontSize: '0.6rem' }}>{t.subtitle}</span>
                          </div>
                        </div>
                        {/* Desc */}
                        <p className="text-white/55 text-xs leading-relaxed mb-3" style={{ lineHeight: '1.6' }}>{t.desc.slice(0, 100)}...</p>
                        {/* Key Stats */}
                        <div className="grid grid-cols-3 gap-1.5 mb-3">
                          {t.stats.map(s => (
                            <div key={s.label} className="text-center p-1.5 rounded-lg" style={{ background: `${t.color}10`, border: `1px solid ${t.color}25` }}>
                              <div className="font-black text-xs" style={{ color: t.color, fontFamily: 'Orbitron, sans-serif', fontSize: '0.65rem' }}>{s.value}</div>
                              <div className="text-xs" style={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.55rem' }}>{s.label}</div>
                            </div>
                          ))}
                        </div>
                        {/* Tag */}
                        <div className="flex items-center justify-between">
                          <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: `${t.color}15`, color: t.color, border: `1px solid ${t.color}30`, fontSize: '0.6rem', fontFamily: 'Orbitron, sans-serif' }}>{t.tag}</span>
                          <div className="flex items-center gap-1 text-xs font-bold" style={{ color: t.color }}>
                            <span style={{ fontSize: '0.7rem' }}>进入深度解析</span>
                            <i className="ri-arrow-right-line text-xs" />
                          </div>
                        </div>
                        {/* Arrow */}
                        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-full" style={{ width: 0, height: 0, borderLeft: '7px solid transparent', borderRight: '7px solid transparent', borderTop: `7px solid ${t.color}60` }} />
                      </div>
                    </div>
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scanDown {
          from { top: 0; opacity: 1; }
          to { top: 100%; opacity: 0; }
        }
      `}</style>
    </div>
  );
}
